import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileXlsx = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 18,
	viewBox: "0 0 14 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.25 0C1.00898 0 0 1.00898 0 2.25V15.75C0 16.991 1.00898 18 2.25 18H11.25C12.491 18 13.5 16.991 13.5 15.75V5.625H9C8.37773 5.625 7.875 5.12227 7.875 4.5V0H2.25ZM2.25 8.25H6.3V10.5H2.25V8.25ZM7.2 8.25H11.25V10.5H7.2V8.25ZM2.25 11.4H6.3V13.65H2.25V11.4ZM7.2 11.4H11.25V13.65H7.2V11.4Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 0V4.5H13.5L9 0Z",
		fill: "currentColor"
	})]
});
export default SvgFileXlsx;
